module.exports = __webpack_public_path__ + "static/media/proemailPremium.636a4211.svg";